import { useCallback } from 'react'
import { useAnalyticsTrack } from '@/features/amplitude'
import { BANKING_EVENTS } from './banking-analytics.constants'
import type { OfferSourceValue } from './banking-analytics.types'

export const useBankingAnalytics = () => {
  const track = useAnalyticsTrack()

  const trackOfferViewed = useCallback(
    (source: OfferSourceValue) => {
      track(BANKING_EVENTS.OfferViewed, { offer_source: source })
    },
    [track]
  )

  const trackOfferClicked = useCallback(
    (source: OfferSourceValue) => {
      track(BANKING_EVENTS.OfferClicked, { offer_source: source })
    },
    [track]
  )

  const trackOfferDismissed = useCallback(
    (source: OfferSourceValue) => {
      track(BANKING_EVENTS.OfferDismissed, { offer_source: source })
    },
    [track]
  )

  const trackApplicationOpened = useCallback(() => {
    track(BANKING_EVENTS.ApplicationOpened, { offer_source: 'unknown' })
  }, [track])

  return {
    trackOfferViewed,
    trackOfferClicked,
    trackOfferDismissed,
    trackApplicationOpened,
  }
}
